const DEFAULT_LIMIT = 10000;
const DEFAULT_SKIP = 0;
import moment from 'moment'

const defaultState = {
	data: [],
	filter: {
		limit: DEFAULT_LIMIT,
		skip: DEFAULT_SKIP
	}
};

function listLens(state = defaultState, action) {
	switch (action.type) {
		case 'RESET_STATE':
			return defaultState;
		case 'GET_ALL_LENS_SUCCESS': {
			try {
				let data = action.payload;
				const total = action.payload.total
				return {
					...state,
					data,
					total
				};
			} catch (err) {
				console.log(err)
				return defaultState
			}
		}
		case 'EDIT_LENS_SUCCESS': {
			return {
				...state,
			}
		}
		case 'CREATE_LENS_SUCCESS': {
			let data = action.payload;
			return {
				...state,
				data
			}
		}
		case 'DELETE_LENS_SUCCESS': {
			return {
				...state,
			}
		}
		default:
			return state;
	}
}

export default listLens;



// WEBPACK FOOTER //
// ./routes/app/routes/lens-list/reducer/list.js